/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MicroConsultingInfoResponse
 */
export interface MicroConsultingInfoResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MicroConsultingInfoResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {number}
     * @memberof MicroConsultingInfoResponse
     */
    hourlyRate?: number;
    /**
     * 
     * @type {string}
     * @memberof MicroConsultingInfoResponse
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof MicroConsultingInfoResponse
     */
    description?: string;
}

/**
 * Check if a given object implements the MicroConsultingInfoResponse interface.
 */
export function instanceOfMicroConsultingInfoResponse(value: object): value is MicroConsultingInfoResponse {
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function MicroConsultingInfoResponseFromJSON(json: any): MicroConsultingInfoResponse {
    return MicroConsultingInfoResponseFromJSONTyped(json, false);
}

export function MicroConsultingInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MicroConsultingInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isActive': json['isActive'],
        'hourlyRate': json['hourlyRate'] == null ? undefined : json['hourlyRate'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function MicroConsultingInfoResponseToJSON(value?: MicroConsultingInfoResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'isActive': value['isActive'],
        'hourlyRate': value['hourlyRate'],
        'currency': value['currency'],
        'description': value['description'],
    };
}

